<template>
  <div>
    <div class="flex-spc-x">
      <div>
        <jd-button
          type="blue"
          :disabled="limitNum == questionsList.length || isDisabled"
          @click="settingTopic"
        >
          题目设置
        </jd-button>
        <span class="ml8">({{ questionsList.length }}/{{ limitNum }})</span>
      </div>
      <span v-if="questionsList.length > 0"
        >{{ computedText }}：{{ totalScore }}{{ computedUnit }}</span
      >
    </div>
    <jd-table
      class="mt16"
      :tableData="questionsList"
      :tableInfo="newTableInfo"
      :isIndex="isIndex"
      :indexWidth="indexWidth"
      :span-method="spanMethod"
      v-show="questionsList.length > 0"
    >
      <template #questionTypeSlot="{ row }">
        {{ questionType(row.type) }}
      </template>
      <template #questionNameSlot="{ row }">
        <div>
          <img
            v-if="row.type == 1 || row.type == 2"
            :src="row.questionPicUrl"
            class="img-w-auto"
            alt=""
          />
          <span>{{ row.title }}</span>
        </div>
      </template>
      <template #questionContentSlot="{ row, rowIndex }">
        <div>
          <div
            v-for="item in getNowOption(row.options, rowIndex)"
            :key="item.id"
            class="option-text"
          >
            <span v-if="row.type == 1 || row.type == 2">{{
              item.description
            }}</span>
            <img v-else class="img-w" :src="item.picUrl" alt="" />
            <img
              v-if="selectIcon && item.isCorrect"
              class="right-icon"
              :src="selectIcon"
              alt=""
            />
          </div>
          <jd-button
            v-if="row.options && row.options.length > 3"
            type="blueText"
            @click="showAllOptions(row, rowIndex)"
          >
            查看全部
          </jd-button>
        </div>
      </template>
      <template #scoreSlot="{ row, rowIndex }">
        <el-input
          v-if="!isMerge || rowIndex === 0"
          class="w100"
          v-model="row.score"
          placeholder="请输入"
          :disabled="isDisabled"
          @input="row.score = getNumberData(1, $event, 0, 0, 999999)"
        />
      </template>
      <template #operationSlot="{ row, rowIndex }">
        <jd-button type="blueText" @click="editQuestionSetting(row, rowIndex)"
          >修改</jd-button
        >
        <jd-button
          type="blueText"
          :disabled="isDisabled"
          @click="deleteQuestionSetting(rowIndex)"
          >删除</jd-button
        >
        <jd-button
          type="blueText"
          @click="upQuestionSetting(rowIndex)"
          v-if="rowIndex != 0"
          >上移</jd-button
        >
        <jd-button
          type="blueText"
          @click="downQuestionSetting(rowIndex)"
          v-if="rowIndex != questionsList.length - 1"
          >下移</jd-button
        >
      </template>
    </jd-table>
    <topicSettingDialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      :currentRow="currentRow"
      :isEdit="isEdit"
      :isDisabled="isDisabled"
      @confirm="handleConfirm"
    />
  </div>
</template>
<script>
import topicSettingDialog from "./topicSettingDialog.vue";
export default {
  components: {
    topicSettingDialog,
  },
  props: {
    limitNum: {
      type: Number,
      default: 50,
    },
    computedText: {
      type: String,
      default: "累计总分",
    },
    computedUnit: {
      type: String,
      default: "分",
    },
    tableInfo: {
      type: Array,
      default: () => [],
    },
    isIndex: {
      type: Boolean,
      default: true,
    },
    indexLabel: {
      type: String,
      default: "排序",
    },
    indexWidth: {
      type: Number,
      default: 80,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isMerge: {
      type: Boolean,
      default: false,
    },
    selectIcon: {
      type: String,
      default: "",
    },
    questions: {
      type: Array,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentIndex: 0,
      isEdit: 0,
      currentRow: {},
      dialogVisible: false,
      questionsList: [],
      defaultInfo: [
        {
          label: "题目类型",
          slot: "questionTypeSlot",
          minWidth: 100,
        },
        {
          label: "题目名称（50个字以内）",
          slot: "questionNameSlot",
          minWidth: 100,
        },
        {
          label: "题目内容",
          slot: "questionContentSlot",
          minWidth: 100,
        },
        {
          label: "答对分值",
          slot: "scoreSlot",
          minWidth: 120,
        },
        {
          label: "操作",
          prop: "operation",
          slot: "operationSlot",
          minWidth: 100,
        },
      ],
    };
  },
  computed: {
    newTableInfo() {
      return this.tableInfo.length > 0 ? this.tableInfo : this.defaultInfo;
    },
    // 计算总分
    totalScore() {
      return this.questionsList.reduce(
        (sum, q) => sum + Number(q.score || 0),
        0
      );
    },
  },
  watch: {
    isMerge(val) {
      if (val && this.questionsList.length > 0) {
        this.questionsList.forEach(
          (q) => (q.score = this.questionsList[0].score)
        );
      }
    },
    questions: {
      handler(newVal, oldVal) {
        this.questionsList = newVal;
        if(this.isMerge) {
          this.questionsList.forEach(
            (q) => (q.score = this.questionsList[0].score)
          );
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  methods: {
    // 表格合并方法：isMerge时合并答对分值列
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (!this.isMerge) return { rowspan: 1, colspan: 1 };

      // 找到scoreSlot对应的列索引（跳过序号列）
      const scoreColumnIndex = this.isIndex ? 4 : 3;

      if (columnIndex === scoreColumnIndex) {
        if (rowIndex === 0) {
          // 第一行合并所有行
          return {
            rowspan: this.questionsList.length,
            colspan: 1,
          };
        } else {
          // 其他行不渲染
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      return { rowspan: 1, colspan: 1 };
    },

    editQuestionSetting(row, rowIndex) {
      this.dialogVisible = true;
      this.currentIndex = rowIndex;
      this.isEdit = 1;
      this.currentRow = row;
    },
    // 删除题目
    deleteQuestionSetting(index) {
      this.questionsList.splice(index, 1);
    },
    // 题目类型
    questionType(type) {
      const typeMap = {
        1: "单选题",
        2: "多选题",
        4: "图片单选题",
        5: "图片多选题",
      };
      return typeMap[type] || "";
    },
    handleConfirm(form) {
      if (this.isEdit==1) {
        this.questionsList[this.currentIndex] = {...this.questionsList[this.currentIndex],...form};
      } else if (this.isEdit==0) {
        this.questionsList.push({ ...form, score: "" });
      }
      this.questionsList = this.questionsList.map((item, index) => {
        return { ...item, sort: index + 1 };
      });
      this.$emit("update:questions", this.questionsList);
    },
    settingTopic() {
      if (this.questionsList.length >= this.limitNum) {
        this.$message({
          message: "最多只能添加" + this.limitNum + "条题目",
          type: "warning",
        });
        return;
      }
      this.dialogVisible = true;
      this.isEdit = 0;
    },
    upQuestionSetting(index) {
      this.questionsList[index] = this.questionsList.splice(
        index - 1,
        1,
        this.questionsList[index]
      )[0];
      this.$emit("update:questions", this.questionsList);
    },
    downQuestionSetting(index) {
      this.questionsList[index] = this.questionsList.splice(
        index + 1,
        1,
        this.questionsList[index]
      )[0];
      this.$emit("update:questions", this.questionsList);
    },
    // 获取当前的选项(超过三条进行截取, 点击了展开则显示全部)
    getNowOption(options) {
      if (options && options.length > 3) {
        return options.slice(0, 3);
      }
      return options;
    },
    // 点击查看全部
    showAllOptions(row, rowIndex) {
      this.dialogVisible = true;
      this.currentIndex = rowIndex;
      this.isEdit = 2;
      this.currentRow = row;
    },
  },
};
</script>
<style lang="scss" scoped>
.img-w-auto {
  width: 100px;
  height: auto;
}
.img-w {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
.right-icon {
  width: 20px;
  height: 20px;
  margin-left: 8px;
}

.option-text {
  display: flex;
  align-items: center;
}
</style>
